export default "__VITE_ASSET__YQV45VXQ__"